import { Switch as cSwitch } from '@coreui/vue';
import { api } from '@/f1/service';
import punycode from 'punycode';
import reg from '@/f1/reg';
// import codes from '@/f1/codes';
import _ from 'lodash';
// import the css (OPTIONAL - you can provide your own design)
import StepProgress from 'vue-step-progress';
import 'vue-step-progress/dist/main.css';
import PolicyList from '../../policy/Policy.List.i18n';
import Language from './language';
import { LangStatus } from '@/f1/service/i18n'

const _i18n_data = {
  saved: {
    EN : `saved`,
    KO : `저장되었습니다`,
  },
  updated: {
    EN : `updated`,
    KO : `업데이트되었습니다`,
  },
};

export default {
  computed: { i18n_data() { return _i18n_data; } }, // i18n 메세지 변환용.
  props : ['is_first'],
  components: { cSwitch, StepProgress, PolicyList, Language },
  filters: {},
  data : () => {
    return {
      LangStatus,
      show : false,
      // 새로운 변수
      // steps : ['What is your FQDN(Domain) ?', 'Set Scanning Policy', 'Agreement on Terms of Use', 'Complete'],
      // TODO : 국가별로 자동 스위칭 되도록 변경 필요
      steps : {
        EN : ['Tell us your FQDN(Domain)', 'Set Scanning Policy', 'Agreement on Terms of Use', 'Complete'],
        KO : ['저희에게 도메인을 알려주세요', '정책을 설정해주세요', '확인해주세요', '완료되었어요!'],
      },
      status : {
        agree1 : false,
        agree2 : false,
        agree3 : false,
        agree4 : false,
        step : 0,
        site_id : -1,
        policy_id : -1,
        interval : 3, // hour
      },
      model : { is_https : true, fqdn : '' },
      policy : { depth: 5, links: 20, limit: 50, timeout: 5, delay: 50 },
      policy_description : 'Quick Setup Policy Sample',
      policy_has : false,
      policy_selected : false,
      modal_policy : false
    }
  },
  // computed : {
    // redir() {
    //   // console.log(`${location.protocol}//${location.hostname == 'localhost' ? 'www.f1secaas.net' : location.hostname.replace('console.', 'www')}/ToS`)
    //   return `${location.protocol}//${location.hostname == 'localhost' ? 'www.f1secaas.net' : location.hostname.replace('console.', 'www.')}/ToS`
    // }
  // },
  methods: {
    // new
    async next(step = undefined) {
      try {
        if(step) { this.status.step = step }
        else {
          if(this.status.step == 0 && !this.model.fqdn) { this.$refs.fqdn.$el.focus(); return this.$toastr.e("require FQDN(domain)") }
          if(this.status.step == 0 && !this.check_fqdn(this.model.fqdn)) { this.$refs.fqdn.$el.focus(); return this.$toastr.e("FQDN(domain) is incorrect") }
          if(this.status.step == 2 && !this.model.is_start) { this.$refs.agreement.focus(); return this.$toastr.e("require Agreement on Terms of Use") }
          if(this.status.step == 2 && !await this.save()) { return this.$toastr.e("save failed") }

          this.status.step = this.status.step >= this.steps.length ? this.steps.length : this.status.step + 1
        }
      } catch (e) { console.log(e) }
    },
    prev(step = undefined) {
      if(step) { this.status.step = step }
      else { this.status.step = this.status.step <= 0 ? 1 : this.status.step - 1 }
    },

    // ui method
    check_fqdn(fqdn) {
      try {
        fqdn = _.trim(fqdn);
        if(!fqdn || !reg.domain.test(punycode.toASCII(fqdn))) { return false }
        if(reg.prevent_domain.test(punycode.toASCII(fqdn))) { return false }
        return true
      } catch (e) { console.error(e) }
    },
    go_list() { this.$router.push({ name : 'wmds_site'}); this.$parent.$emit('count', 2); this.$parent.$emit('refresh') },
    go_site() { this.$router.push({ name : 'wmds_site', params : { id : this.status.site_id }}); this.$parent.$emit('refresh') },
    go_policy() { this.$router.push({ name : 'wmds_policy', params : { id : this.status.policy_id }}); },
    cron_parse(cron, is_add=true) {
      let origin = cron.split(' ')
      // console.log('origin', origin, origin[1] != '*' ? origin[1].replace(/[\\*]/gm, '') : 0)
      let min_has_interval = origin[0].indexOf('/') > -1
      let hour_has_interval = origin[1].indexOf('/') > -1
      if(hour_has_interval) {
        // 매시간별 반복은 시간 차이 기준으로 컨버팅 불필요
      } else {
        if(origin[1] != '*') {
          origin[1] =  (Number(origin[1] != '*' ? origin[1].replace(/[/|\\*]/gm, '') : 0) + 24 + (is_add ? + (new Date().getTimezoneOffset() / 60) : - (new Date().getTimezoneOffset() / 60))) % 24
        }
      }

      if(min_has_interval) { '*/' + origin[0] }
      if(hour_has_interval) { '*/' + origin[1] }
      // console.log(origin.join(' '))

      return origin.join(' ')
    },
    async save() {
      if(!this.policy_selected)
      {
        try {
          // build policy info
          let rs = await api.wmds.WMDS_Call('policy', 'insert', Object.assign({}, { policy : this.policy, description : this.policy_description }));
          if(rs.error) { return false }
          this.status.policy_id = rs.body.id
          console.log('generate site done')
        } catch(e) { this.$toastr.e(e.data ? e.data.message : e.statusText);  return false  }
      }

      try {
        // build site info
        let name = _.startsWith(this.model.fqdn, 'www.') ? this.model.fqdn.split('.')[1] : this.model.fqdn.split('.')[0];
        let site = { fqdn : this.model.fqdn,
          name : name,
          is_alive: true,
          is_cron: false,
          is_start: this.model.is_start,
          is_js: true,
          policy_id : this.status.policy_id,
          schedule: _.map([`0 ${this.status.interval} * * *`], x => this.cron_parse(x)), // 새벽 3시 자동 설정
          config: {
              seeds : [`${this.model.is_https ? 'https' : 'http'}://${this.model.fqdn}`],
              subs: [],
              prevents: []
            }
          }
        let rs = await api.wmds.WMDS_Call('site', 'insert', Object.assign({}, site));
        if(rs.error) { return false }
        this.status.site_id = rs.body.id
        console.log('generate site done')

        // 동의 기록
        try {
          let rs = await api.wmds.WMDS_Call('site', 'agree', { ts : new Date().getTime() });
          if(rs.error) { return this.$toastr.e("apply agreement failed") }
          // 시스템 로그가 남아야 함, 동의 부분 관련
        } catch (e) { console.log(e); this.$toastr.e("apply agreement failed") }

      } catch(e) { this.$toastr.e(e.data ? e.data.message : e.statusText); return false  }

      this.$toastr.s(this.i18n_data['saved'][this.i18n || 'EN']);

      return true
    },

    async check_policy() {
      // this part change dynamic loding
      this.add = false;
      let so = {
        target : 'policy', cmd : 'list',
        body : { sort : [{name : 'id', op : 'desc'}], or : [], and : [{ name : "is_del", value : false, op : '='}] },
        limit : 1
      }
      let rs = await api.wmds.WMDS(so);
      if(rs.error) { return this.$toastr.e("load failed") }
      this.policy_has = (rs.body || []).length > 0
    },
  },
  watch: { '$route' (to, from) { console.log(from.path) } },
  created: function() {   console.log('site.quick.setup.vue', 'created'); },
  destroyed: function() { console.log('site.quick.setup.vue', 'destroyed'); },
  mounted: function() {
    console.log('site.quick.setup.vue', 'mounted');
    this.check_policy()
  },
}
